import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TimeTableItemComponent } from '../time-table-item/time-table-item.component';
import { CourseItemComponent } from '../course-item/course-item.component';

@Component({
    selector: 'app-task-list-student-view',
    templateUrl: './task-list-student-view.component.html',
    imports: [
        TimeTableItemComponent,
        CourseItemComponent,
        CommonModule
    ],
    styleUrls: ['./task-list-student-view.component.css']
})
export class TaskListStudentViewComponent {
  datas = Array(50).fill(12)

}
